import Checkbox from "components/check-box"
import styled from "styled-components";
import { horizontalScale, mobileMediaQuery } from "utils/helpers";

export enum CheckBoxTypeList {
  personalData = 'personalData',
  orderRules = 'orderRules',
}

export type CheckBoxTypes = {
  [CheckBoxTypeList.personalData]: boolean;
  [CheckBoxTypeList.orderRules]: boolean;
}

const Agreements = ({ isChecked, toggleCheckbox }: { isChecked: CheckBoxTypes, toggleCheckbox: (type?: string) => void }) => {
  return (
    <AgreementLink>
      <Checkbox
        type={CheckBoxTypeList.personalData}
        checked={isChecked[CheckBoxTypeList.personalData]}
        toggleCheckbox={toggleCheckbox}
      >
        <CheckboxContent>
          Я даю свое{' '}
          <a
            href={`${process.env.PUBLIC_URL}/Согласие_на_обработку_персональных_данных_Cake_Buro.pdf`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Согласие
          </a>{' '}
          на обработку персональных данных в соответствии с{' '}
          <a
            href={`${process.env.PUBLIC_URL}/Политика_обработки_ПДн_Cake_Buro.pdf`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Политикой обработки персональных данных
          </a>
        </CheckboxContent>
      </Checkbox>
      <Checkbox
        type={CheckBoxTypeList.orderRules}
        checked={isChecked[CheckBoxTypeList.orderRules]}
        toggleCheckbox={toggleCheckbox}
      >
        <CheckboxContent>
          Я соглашаюсь с{' '}
          <a
            href={`${process.env.PUBLIC_URL}/Правила_заказа_авторских_тортов_Cake_Buro.pdf`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Правилами заказа авторских тортов
          </a>
        </CheckboxContent>
      </Checkbox>
    </AgreementLink>
  )
}

export default Agreements;

const AgreementLink = styled.div`
  font-size: ${horizontalScale(16)};
  line-height: ${horizontalScale(20)};
  color: #d1d8d8;
  display: flex;
  gap: 15px;
  flex-direction: column;

  a {
    color: #CFAF4E;
    text-decoration: underline;
  }

  ${mobileMediaQuery(
    (css, mobileScale) => css`
      font-size: ${mobileScale(12)};
      line-height: ${mobileScale(14)};
      text-align: left;
      margin-bottom: 20px;
      height: 140px;
    `
  )}
`;

const CheckboxContent = styled.div`
  position: relative;
  top: 2px;
`;